import {
  Box,
  Tab,
  Tabs,
  Button,
  Container,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import useApi from "../../../hooks/useApi";
import { useEffect, useState } from "react";
import GlobalHeader from "../../../components/GlobalHeader";
import SnackAlert from "../../../components/SnackAlert";
import useSnack from "../../../hooks/useSnack";
import { LoadingButton } from "@mui/lab";
import { Link, useParams } from "react-router-dom";
import { useUser } from "../../../hooks/useUser";
import { Audio } from "react-loading-icons";
import ModalView from "./modal";
import EventoPendiente from "./EventoPendiente";
import Cancion from "./cancion";
import CancionPc from "./cancionPC";
import FeedbackVerificacion from "../../../components/FeedbackVerificacion";
import Correcciones from "./Correcciones";
import useLogos from "../../../hooks/useLogos";

export default function ViewProductorSends() {
  const { loadApi, loadingApi } = useApi();
  const { songId } = useParams();
  const { user, updateUser } = useUser();
  const [mainData, setMainData] = useState(false);
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [openDialog, setOpenDialog] = useState(false);
  const { logoClaro } = useLogos();
  const isSM = useMediaQuery(useTheme().breakpoints.down("md"));
  // Aceptar una fecha no es lo mismo que escuchar un tema, así que se
  // pueden mirar por separado. Arranca en "todos" para no esconder nada.
  const [pestana, setPestana] = useState("todos");

  useEffect(() => {
    loadApi(`productor/canciones/allPendings`, true, "get")
      .then((response) => {
        setMainData(response.data || false);
      })
      .catch((e) => {
        showSnack(e.message, "error", false);
      });
  }, []);

  // `tipo` llega desde la tarjeta: el modal lo usa para pedir los motivos de
  // rechazo que corresponden (rechazar un evento no se parece a rechazar una
  // canción). Si no viene, se asume canción, que es lo de siempre.
  function updateSend(status, id, url, preview, tipo = "cancion") {
    setOpenDialog({ status, id, url, preview, tipo });
  }

  function loadDecision(id, form) {
    loadApi(`productor/envios/${id}`, true, "put", form)
      .then((response) => {
        showSnack(response.data.message);
        setOpenDialog(false);
        // `id` acá es el del envío; la lista se filtra por el mismo campo.
        setMainData((aData) =>
          aData.filter((item) => item.envioId !== id)
        );
        updateUser();
        window.location.reload();
      })
      .catch((error) => {
        showSnack(error.message, "error");
        console.log(form.status)
      });
  }

  // El backend devuelve las dos cosas juntas; acá se separan para poder
  // mostrarlas por pestaña sin pedir dos veces lo mismo.
  const pendientes = Array.isArray(mainData) ? mainData : [];
  const eventos = pendientes.filter((item) => item.tipo_envio === "evento");
  const canciones = pendientes.filter((item) => item.tipo_envio !== "evento");

  return (
    <>
      <GlobalHeader />
      <Container maxWidth="md" disableGutters sx={{ px: { xs: 1, sm: 2 } }}>
        <FeedbackVerificacion />
        {/* Correcciones que pidió el equipo tras un reporte del artista */}
        <Correcciones showSnack={showSnack} />
      </Container>
      {!mainData ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: `calc(100vh - ${
              window.document.getElementById("GlobalHeader")?.offsetHeight ||
              "64"
            }px - 32px)`,
          }}
        >
          <Audio fill="#F27224" />
        </Box>
      ) : mainData.length > 0 ? (
        <>
          {/* Los eventos se revisan distinto que las canciones, así que se
              pueden separar. Solo aparecen las pestañas si hay de los dos. */}
          {canciones.length > 0 && eventos.length > 0 && (
            <Container maxWidth="md" disableGutters sx={{ px: { xs: 1, sm: 2 } }}>
              <Tabs
                value={pestana}
                onChange={(e, valor) => setPestana(valor)}
                sx={{ mb: 2 }}
              >
                <Tab value="todos" label={`Todos (${mainData.length})`} />
                <Tab value="canciones" label={`Canciones (${canciones.length})`} />
                <Tab value="eventos" label={`Eventos (${eventos.length})`} />
              </Tabs>
            </Container>
          )}

          {pestana !== "canciones" && eventos.length > 0 && (
            <Container maxWidth="md" disableGutters sx={{ px: { xs: 1, sm: 2 } }}>
              {eventos.map((item) => (
                <EventoPendiente
                  key={item.envioId}
                  mainData={item}
                  loadingApi={loadingApi}
                  updateSend={updateSend}
                />
              ))}
            </Container>
          )}

          {pestana !== "eventos" &&
            canciones.length > 0 &&
            (isSM ? (
              canciones.map((item, i) => (
                <Cancion
                  key={item.envioId || i}
                  mainData={item}
                  showSnack={showSnack}
                  loadingApi={loadingApi}
                  updateSend={updateSend}
                />
              ))
            ) : (
              <CancionPc
                mainData={canciones}
                showSnack={showSnack}
                loadingApi={loadingApi}
                updateSend={updateSend}
              />
            ))}
        </>
      ) : (
        <Container>
          <Stack
            sx={{
              height: "calc( 100vh - 104px )",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={logoClaro}
              alt="Radar Freim"
              style={{ width: "300px" }}
            />
            <Typography variant="h5" mt={4} textAlign="center">
              ¡Upps! No hay Envios pendientes
            </Typography>
          </Stack>
        </Container>
      )}
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      <ModalView
        open={openDialog}
        loadingApi={loadingApi}
        setOpen={setOpenDialog}
        loadDecision={loadDecision}
      />
    </>
  );
}
